import React from 'react'

import './Conditions.css'

const Conditions = (props) => {
  return (
    <div className="conditions-container">
      {props.children}
    </div>
  )
}

export default Conditions